__turbopack_context__.v({
  "animateRow": "style-module-scss-module__4n7MRW__animateRow",
  "gTable": "style-module-scss-module__4n7MRW__gTable",
  "gTableCol": "style-module-scss-module__4n7MRW__gTableCol",
  "gTableNoData": "style-module-scss-module__4n7MRW__gTableNoData",
  "gTableRow": "style-module-scss-module__4n7MRW__gTableRow",
  "gTableRowSkeleton": "style-module-scss-module__4n7MRW__gTableRowSkeleton",
  "gTableRow__body": "style-module-scss-module__4n7MRW__gTableRow__body",
  "gTableRow__head": "style-module-scss-module__4n7MRW__gTableRow__head",
  "gTableRow__selected": "style-module-scss-module__4n7MRW__gTableRow__selected",
});
